import React, { useState } from "react"
import { motion } from "framer-motion"
// import { Doughnut } from "react-chartjs-2"
import Navbar from "../components/Navbar"
import Head from "../components/Head"

function AboutPage({ location }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Head />
      <div className="h-screen w-screen bg-primary font-mono">
        <Navbar open={open} setOpen={setOpen} location={location} />
        <div className={`flex bg-primary ${open ? "mt-44" : ""}`}>
          <div className="p-10 text-info lg:p-28">
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-2xl font-bold md:text-4xl"
            >
              About
            </motion.h1>
            <div className="flex flex-col lg:flex-row my-8 lg:justify-between">
              <div className="w-full mb-10 lg:w-4/6">
                <motion.p
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 1 }}
                >
                  Hello, My name is Tenzin Tamdin. I am a Bangalore-based
                  frontend developer, India. Currently, I have been looking to
                  work in mobile app project with a solid team to learn and
                  built products which solve real worlds problems.
                </motion.p>
                <br />
                <motion.p
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 1.5 }}
                >
                  I enjoy the process of creating great user experience websites
                  or app designed by UI/UX Designer. Earlier I have worked on
                  some project with React.js and currently I have been exploring
                  flutter since I was curious about Mobile App Development.
                </motion.p>
                <br />
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 2 }}
                >
                  <p>Here are a few technologies that I work with:-</p>
                  <br />
                  <div className="flex flex-row w-full justify-around">
                    <ul className="list-disc">
                      <li>HTML and CSS</li>
                      <li>React.js</li>
                      <li>Material UI</li>
                      <li>Bootstrap</li>
                    </ul>
                    <ul className="list-disc">
                      <li>Javascript</li>
                      <li>Node.js</li>
                      <li>Flutter</li>
                      <li>Firebase</li>
                    </ul>
                  </div>
                </motion.div>
              </div>
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 2.5 }}
                className="w-full lg:w-2/6 lg:block"
              >
                <img
                  src="https://github-readme-stats.vercel.app/api/top-langs/?username=tentamdin&layout=compact&theme=algolia"
                  alt=""
                  className="m-auto"
                ></img>
                {/* <Doughnut
                  options={{
                    maintainAspectRatio: false,
                    legend: {
                      position: "right",
                    },
                    title: {
                      display: true,
                      text: "Top languages (Based on lines of code written)",
                      fontColor: "#D4EAE9",
                      position: "bottom",
                    },
                  }}
                  data={{
                    labels: [
                      "python",
                      "javascript",
                      "c",
                      "typescript",
                      "dart",
                      "java",
                    ],
                    datasets: [
                      {
                        data: [9861, 3032, 880, 430, 351, 168],
                        backgroundColor: [
                          "rgb(209, 140, 29)", // py
                          "rgb(217, 214, 26)", // js
                          "rgb(104, 112, 117)", // c
                          "rgb(29, 137, 209)", //ts
                          "rgb(131, 79, 214)", // dart
                          "rgb(237, 78, 50)", // java
                        ],
                        borderColor: [
                          "rgb(209, 140, 29)", // py
                          "rgb(217, 214, 26)", // js
                          "rgb(104, 112, 117)", // c
                          "rgb(29, 137, 209)", //ts
                          "rgb(131, 79, 214)", // dart
                          "rgb(237, 78, 50)", // java
                        ],
                      },
                    ],
                  }}
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutPage
